"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  init: function init(options) {
    this.baseUrl = options.baseUrl;
    this.urls = {
      basketApiGet: "".concat(this.baseUrl, "/api/basket"),
      basketApiPatch: "".concat(this.baseUrl, "/api/basket"),
      basketApiDelete: "".concat(this.baseUrl, "/api/remove"),
      splitApi: "".concat(this.baseUrl, "/api/split")
    };
  }
};
exports["default"] = _default;